export enum ETaskStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  IN_REVIEW = 'IN_REVIEW',
  PENDING = 'PENDING'
}
